<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
      <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>

<div class="mx-4">
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
            <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                <nz-form-label nzRequired>
                    Desde
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'El número debe ser mayor que 0 y menor que ' + data.max">
                    <input onfocus="select()" formControlName="from" nz-input type="number"
                        placeholder="Indique la cantidad" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                <nz-form-label nzRequired>
                    Hasta
                </nz-form-label>
                <nz-form-control [nzErrorTip]="'El número debe ser mayor que ' + validateForm.controls.from.value + ' y menor que ' + data.max">
                    <input onfocus="select()" formControlName="to" nz-input type="number"
                        placeholder="Indique la cantidad" />
                </nz-form-control>
            </nz-form-item>
        </div>
    </form>
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        <button type="submit" (click)="submitForm()" [disabled]="!validateForm.valid" class="button primary-button">
            Aceptar
        </button>
    </div>
</div>
